import { FC } from "react";
import WP, { PickerData } from "react-simple-wheel-picker";

import "./styles.css";

interface props {
  items: PickerData[];
  selectedId: string;
  onChange: (itemId: string) => void;
}

export const WheelPicker: FC<props> = (props) => {
  const handleOnChange = (target: PickerData) => {
    props.onChange(target.id);
  };

  return (
    <div className="hide-scrollbar hide-check-mark select-none">
      <WP
        data={props.items || []}
        onChange={handleOnChange}
        height={150}
        itemHeight={30}
        selectedID={props.selectedId}
        focusColor="transparent"
        color="#ccc"
        activeColor="#333"
        backgroundColor="#fff"
        shadowColor="transparent"
      />
    </div>
  );
};
